import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
export const RenderComponent = ({ drawerOpts, }) => {
    const elmId = 'zen_detail_drawer';
    useEffect(() => {
        const element = React.cloneElement(drawerOpts.component, {});
        const container = document.getElementById(elmId);
        let unmount;
        // react 18
        const reactCreateRoot = drawerOpts.creatRoot;
        // react 16
        const reactDomRender = drawerOpts?.react16Dom?.render;
        const unmountComponentAtNode = drawerOpts.react16Dom?.unmountComponentAtNode;
        if (reactCreateRoot) {
            const root = reactCreateRoot?.(container);
            root?.render(element);
            unmount = () => {
                setTimeout(() => {
                    root?.unmount();
                });
            };
        }
        else {
            reactDomRender?.(element, container);
        }
        return () => {
            if (reactCreateRoot) {
                unmount?.();
            }
            else {
                unmountComponentAtNode?.(container);
            }
        };
    }, []);
    return _jsx("div", { id: elmId, style: { paddingBottom: '16px' } });
};
